import React from 'react';

const SearchIcon = ({ width = 18, height = 18, color = '#667085', ...rest }, ref) => {
  return (
    <svg
      {...rest}
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0817 12.057C8.64458 14.0089 5.07719 13.8553 2.81801 11.5961C0.393997 9.17212 0.393997 5.24202 2.81801 2.81801C5.24202 0.393997 9.17213 0.393997 11.5961 2.81801C13.8553 5.07718 14.009 8.64457 12.057 11.0817L16.798 15.8226C17.0673 16.092 17.0673 16.5287 16.798 16.798C16.5287 17.0673 16.092 17.0673 15.8226 16.798L11.0817 12.057ZM3.79335 10.6208C1.90802 8.73542 1.90802 5.6787 3.79335 3.79336C5.6787 1.90802 8.73543 1.90802 10.6208 3.79336C12.5047 5.67732 12.5061 8.73091 10.625 10.6167C10.6236 10.618 10.6222 10.6193 10.6207 10.6208C10.6193 10.6222 10.618 10.6236 10.6167 10.6249C8.73092 12.5061 5.67731 12.5047 3.79335 10.6208Z"
        fill={color}
      />
    </svg>
  );
};

export default React.forwardRef(SearchIcon);
